import toUrlParams from '../url/toUrlParams';
import config from './_config';

const API_KEYS = {
  prod: 'QUl6YVN5RDNUY2RxcWUtUFg1eHV1SHpkSFh2ZWhLRzhwUHNCaGlj',
  dev: 'QUl6YVN5QzRURmxoRGlyVUZKTi1WMmNoNmhXOUpGcUJFanJ3UUk0',
};

/**
 * @private
 * Injects the script asynchronously.
 *
 * @param {String} url - the URL from where the script will be loaded
 */
function inject(url) {
  const tag = 'script',
    doc = document,
    script = doc.createElement(tag),
    first = doc.getElementsByTagName(tag)[0];
  script.defer = 1;
  script.async = 1;
  script.src = url;
  first.parentNode.insertBefore(script, first);
}

/**
 * @public
 * Injects and initializes the google maps api script.
 *
 * @param {Object} options - configures the api initialization.
 */
export default function injectMapsApi(options) {
  Object.assign(config, options);
  const queryparams = {
    key: atob(API_KEYS[config.apiKeyEnv]),
    callback: config.onload, // public function
    libraries: 'places',
  };
  const url = 'https://maps.googleapis.com/maps/api/js';
  inject(`${url}${toUrlParams(queryparams)}`);
}
